import { CartLinesUpdateEvent } from '@shopify/events';

(() => {
  const FILE_LIMIT = 50 * 1024 * 1024;
  const ALLOWED = /\.(pdf|ai|eps|png|jpe?g|tiff?|svg)$/i;
  const MAX_UPLOAD_ATTEMPTS = 3;

  function publishDealJourney(name, data) {
    try {
      if (!window.Shopify?.customerPrivacy) {
        window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
          if (!error && window.Shopify?.customerPrivacy) publishDealJourney(name, data);
        });
        return;
      }
      if (!window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()) return;
      const safe = {};
      for (const key of ['productHandle', 'variantId', 'artworkMode', 'stage', 'durationMs']) {
        if (data[key] !== undefined) safe[key] = data[key];
      }
      Promise.resolve(window.Shopify?.analytics?.publish(name, safe)).catch(() => {});
    } catch { /* Measurement must never interrupt ordering. */ }
  }

  function updateDealHeading(root, quantity) {
    if (root.dataset.dealUpsell !== 'true') return;
    const heading = root.querySelector('h1');
    if (heading) heading.textContent = heading.textContent.replace(/^(\s*)(?:100|200)(?=\s)/, (_, spacing) => spacing + quantity);
  }
  document.querySelectorAll('[data-spark-deal-product]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const variants = JSON.parse(root.querySelector('[data-deal-product-json]')?.textContent || '[]');
    const choices = [...root.querySelectorAll('[data-deal-option]')];
    const fileInput = root.querySelector('[data-artwork-file]');
    const emailLater = root.querySelector('[data-artwork-email-later]');
    const artworkNotes = root.querySelector('[data-deal-artwork-notes]');
    const optionsStep = root.querySelector('[data-deal-options-step]');
    const artworkStep = root.querySelector('[data-deal-artwork-step]');
    const artworkActions = root.querySelector('[data-deal-artwork-actions]');
    const continueButton = root.querySelector('[data-deal-continue]');
    const backButtons = [...root.querySelectorAll('[data-deal-back], [data-deal-flow-options]')];
    const addButton = root.querySelector('[data-deal-add]');
    const artworkModeButtons = [...root.querySelectorAll('[data-deal-artwork-mode]')];
    const uploadPanel = root.querySelector('[data-deal-upload-panel]');
    const laterPanel = root.querySelector('[data-deal-later-panel]');
    const fileList = root.querySelector('[data-deal-artwork-file-list]');
    const flowOptions = root.querySelector('[data-deal-flow-options]');
    const flowArtwork = root.querySelector('[data-deal-flow-artwork]');
    const status = root.querySelector('[data-deal-status]');
    const uploadApiBase = root.dataset.uploadApiBase || 'https://configurator.sparkstickers.com';
    let selectedVariant = null;
    let loading = false;
    let step = 'options';
    let previewUrl = '';
    const track = (name, detail = {}) => publishDealJourney(name, {
      productHandle: root.dataset.productHandle,
      variantId: String(selectedVariant?.id || ''),
      artworkMode: emailLater.checked ? 'email_later' : 'upload',
      ...detail,
    });

    const selectedOptions = () => {
      const values = [];
      choices.forEach((group, index) => {
        values[Number(group.dataset.optionIndex ?? index)] = group.querySelector('.is-selected')?.dataset.dealOptionValue || '';
      });
      if (root.dataset.dealUpsell === 'true') values[Number(root.dataset.upsellOptionIndex)] = selectedQuantity();
      return values;
    };
    const selectedQuantity = () => root.dataset.dealUpsell === 'true'
      ? (root.querySelector('[data-deal-quantity-upsell]')?.checked ? '200' : '100')
      : root.dataset.offerQuantity;
    const selectedProperty = (name) => {
      const selected = choices.find((group) => group.dataset.optionName === name)?.querySelector('.is-selected');
      return selected?.dataset.dealCanonicalValue || selected?.dataset.dealOptionValue || '';
    };
    const selectedSize = () => selectedProperty('Size') || root.dataset.offerSize;
    selectedVariant = variants.find((variant) => selectedOptions().every((value, optionIndex) => variant.options[optionIndex] === value))
      || variants.find((variant) => variant.available)
      || variants[0];
    const selectVariant = () => {
      const values = selectedOptions();
      selectedVariant = variants.find((variant) => values.every((value, optionIndex) => variant.options[optionIndex] === value));
      updateUi();
    };
    const money = (cents) => {
      const currency = String(root.dataset.currency || 'CAD').toUpperCase();
      const formatter = new Intl.NumberFormat('en-CA', { style: 'currency', currency });
      return formatter.formatToParts(Number(cents || 0) / 100).map((part) => (
        part.type === 'currency' && currency === 'CAD' ? 'CA$' : part.value
      )).join('');
    };
    const updateUi = () => {
      root.querySelector('[data-deal-price]').textContent = selectedVariant ? money(selectedVariant.price) : 'Unavailable';
      root.querySelector('[data-deal-summary-shape]').textContent = selectedProperty('Shape');
      root.querySelector('[data-deal-summary-finish]').textContent = selectedProperty('Finish');
      root.querySelectorAll('[data-deal-summary-size]').forEach((node) => { node.textContent = selectedSize(); });
      if (root.dataset.dealUpsell === 'true') {
        root.dataset.offerQuantity = selectedQuantity();
        updateDealHeading(root, selectedQuantity());
        root.querySelectorAll('[data-deal-summary-quantity]').forEach((node) => { node.textContent = selectedQuantity(); });
        const upsell = root.querySelector('[data-deal-quantity-upsell]');
        upsell.disabled = loading;
        upsell.closest('.spark-deal__upsell').classList.toggle('is-selected', upsell.checked);
      }
      const compare = root.querySelector('[data-deal-compare]');
      const hasCompare = Number(selectedVariant?.compare_at_price || 0) > Number(selectedVariant?.price || 0);
      compare.hidden = !hasCompare;
      if (hasCompare) compare.textContent = money(selectedVariant.compare_at_price);
      const savings = root.querySelector('[data-deal-savings]');
      if (savings) {
        savings.hidden = !hasCompare;
        if (hasCompare) {
          root.querySelector('[data-deal-savings-amount]').textContent = money(selectedVariant.compare_at_price - selectedVariant.price);
          root.querySelector('[data-deal-savings-percentage]').textContent = Math.round(100 * (selectedVariant.compare_at_price - selectedVariant.price) / selectedVariant.compare_at_price);
        }
      }
      const file = fileInput.files?.[0];
      root.querySelector('[data-artwork-label]').textContent = file ? 'Replace artwork' : 'Drop your artwork here';
      root.querySelector('[data-artwork-dropzone]').classList.toggle('is-email-later', emailLater.checked);
      if (uploadPanel) uploadPanel.hidden = emailLater.checked;
      if (laterPanel) laterPanel.hidden = !emailLater.checked;
      artworkModeButtons.forEach((button) => {
        const active = (button.dataset.dealArtworkMode === 'email_later') === emailLater.checked;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-pressed', String(active));
      });
      renderFile(file);
      const previewOnly = root.dataset.dealPreviewOnly === 'true';
      continueButton.disabled = !selectedVariant || (!selectedVariant.available && !previewOnly);
      addButton.disabled = previewOnly || loading || !selectedVariant?.available || (!emailLater.checked && !file);
      addButton.setAttribute('aria-busy', String(loading));
      const addLabel = root.querySelector('[data-deal-add-label]');
      if (!loading && addLabel) addLabel.textContent = `Add to cart — ${selectedVariant ? money(selectedVariant.price) : 'Unavailable'}`;
      if (previewOnly && addLabel) addLabel.textContent = 'Draft preview — ordering disabled';
    };

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-deal-option-value]');
      if (!button) return;
      const group = button.closest('[data-deal-option]');
      group.querySelectorAll('[data-deal-option-value]').forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-pressed', String(active));
      });
      selectVariant();
    });
    root.querySelector('[data-deal-quantity-upsell]')?.addEventListener('change', selectVariant);
    fileInput.addEventListener('change', () => { emailLater.checked = false; setStatus(''); updateUi(); if (fileInput.files?.length) track('spark_artwork_file_selected'); });
    emailLater.addEventListener('change', () => { if (emailLater.checked) fileInput.value = ''; setStatus(''); updateUi(); });
    artworkModeButtons.forEach((button) => button.addEventListener('click', () => {
      emailLater.checked = button.dataset.dealArtworkMode === 'email_later';
      track('spark_artwork_mode_selected');
      if (emailLater.checked) fileInput.value = '';
      setStatus('');
      updateUi();
    }));
    fileList?.addEventListener('click', (event) => {
      if (!event.target.closest('[data-deal-remove-artwork]')) return;
      fileInput.value = '';
      setStatus('');
      updateUi();
    });
    continueButton.addEventListener('click', () => showStep('artwork'));
    backButtons.forEach((button) => button.addEventListener('click', () => showStep('options')));
    addButton.addEventListener('click', addToCart);

    function showStep(nextStep) {
      if (nextStep === 'artwork' && step !== 'artwork') {
        // Keep this entry snapshot while customers toggle the offer in artwork.
        root.dataset.hideArtworkUpsell = String(root.dataset.dealUpsell === 'true' && !!root.querySelector('[data-deal-quantity-upsell]')?.checked);
        track('spark_artwork_step_opened');
      } else if (nextStep === 'options') {
        root.dataset.hideArtworkUpsell = 'false';
      }
      step = nextStep;
      const isArtwork = step === 'artwork';
      optionsStep.hidden = isArtwork;
      artworkStep.hidden = !isArtwork;
      continueButton.hidden = isArtwork;
      artworkActions.hidden = !isArtwork;
      flowOptions?.classList.toggle('is-active', !isArtwork);
      flowOptions?.classList.toggle('is-complete', isArtwork);
      flowOptions?.setAttribute('aria-current', isArtwork ? 'false' : 'step');
      flowArtwork?.classList.toggle('is-active', isArtwork);
      flowArtwork?.setAttribute('aria-current', isArtwork ? 'step' : 'false');
      setStatus('');
      root.dataset.dealStep = step;
      window.setTimeout(() => focusStep(isArtwork), 0);
      updateUi();
    }

    function focusStep(isArtwork) {
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const flowTarget = root.querySelector('.spark-deal__flow');
      const target = typeof flowTarget?.getBoundingClientRect === 'function'
        ? flowTarget
        : (isArtwork
          ? (artworkStep.querySelector('.spark-config__selection-summary') || artworkStep)
          : root);
      const alignTarget = (behavior) => {
        const headerOffset = document.querySelector('.spark-header-wrap')?.getBoundingClientRect().height || 0;
        const targetRect = target.getBoundingClientRect();
        const topGap = headerOffset + 12;
        const scrollParent = scrollableParent(target);

        if (scrollParent && scrollParent !== document.scrollingElement && scrollParent !== document.documentElement) {
          const parentRect = scrollParent.getBoundingClientRect();
          const top = Math.max(0, scrollParent.scrollTop + targetRect.top - parentRect.top - topGap);
          scrollParent.scrollTo({ top, behavior });
        } else {
          const top = Math.max(0, targetRect.top + window.scrollY - topGap);
          window.scrollTo({ top, behavior });
        }
      };

      const nextFrame = typeof window.requestAnimationFrame === 'function'
        ? window.requestAnimationFrame.bind(window)
        : (callback) => window.setTimeout(callback, 0);
      nextFrame(() => {
        nextFrame(() => alignTarget(prefersReducedMotion ? 'auto' : 'smooth'));
      });
      window.setTimeout(() => alignTarget('auto'), 420);
    }

    function scrollableParent(element) {
      let current = element.parentElement;
      while (current && current !== document.body) {
        const style = window.getComputedStyle(current);
        const canScroll = /(auto|scroll)/.test(style.overflowY) && current.scrollHeight > current.clientHeight;
        if (canScroll) return current;
        current = current.parentElement;
      }
      return document.scrollingElement || document.documentElement;
    }

    function setStatus(message, error = false) {
      if (artworkActions && artworkActions.nextElementSibling !== status) artworkActions.after(status);
      status.textContent = message;
      status.classList.toggle('is-error', error);
    }

    function renderFile(file) {
      if (previewUrl) {
        URL.revokeObjectURL(previewUrl);
        previewUrl = '';
      }
      if (!fileList) return;
      fileList.replaceChildren();
      fileList.hidden = !file;
      if (!file) return;

      const item = document.createElement('li');
      const preview = document.createElement('span');
      preview.className = 'spark-config__artwork-file-preview';
      if (/^image\/(png|jpe?g|svg\+xml)$/i.test(file.type) || /\.(png|jpe?g|svg)$/i.test(file.name)) {
        previewUrl = URL.createObjectURL(file);
        const image = document.createElement('img');
        image.src = previewUrl;
        image.alt = '';
        preview.append(image);
      } else {
        preview.classList.add('is-document');
        preview.setAttribute('aria-hidden', 'true');
        preview.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M6 2.75h8l4 4V21.25H6z"/><path d="M14 2.75v4h4"/></svg>';
        const type = document.createElement('strong');
        type.className = 'spark-config__artwork-file-type';
        type.textContent = file.name.split('.').pop()?.toUpperCase().slice(0, 4) || 'FILE';
        preview.append(type);
      }

      const copy = document.createElement('span');
      copy.className = 'spark-config__artwork-file-copy';
      const name = document.createElement('strong');
      name.textContent = file.name;
      name.title = file.name;
      const meta = document.createElement('small');
      meta.textContent = `${formatFileSize(file.size)} · Ready to attach to order`;
      copy.append(name, meta);

      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'spark-config__artwork-file-remove';
      remove.dataset.dealRemoveArtwork = '';
      remove.setAttribute('aria-label', `Remove ${file.name}`);
      remove.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M4 7h16M9 7V4h6v3m-8 0 1 13h8l1-13M10 11v5m4-5v5"/></svg>';
      item.append(preview, copy, remove);
      fileList.append(item);
    }

    function formatFileSize(bytes) {
      if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} KB`;
      return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
    }

    async function addToCart() {
      if (root.dataset.dealPreviewOnly === 'true') return;
      if (loading || !selectedVariant) return;
      const file = fileInput.files?.[0];
      if (!emailLater.checked && !file) return;
      if (file && file.size > FILE_LIMIT) { track('spark_artwork_validation_failed', { stage: 'file_size' }); return setStatus(`${file.name} is too large. Maximum file size is 50 MB.`, true); }
      if (file && !ALLOWED.test(file.name)) { track('spark_artwork_validation_failed', { stage: 'file_type' }); return setStatus('Accepted files are JPG, PNG, PDF, AI, EPS, TIF, TIFF, or SVG.', true); }
      track('spark_deal_cart_attempted');
      let journeyStage = file ? 'upload' : 'cart';
      const journeyStarted = performance.now();
      loading = true;
      root.querySelector('[data-deal-add-label]').textContent = 'Adding…';
      setStatus('Hang tight! We’re preparing your deal and adding it to your cart…');
      updateUi();
      let cartUpdate;
      let itemWasAdded = false;
      try {
        const properties = {
          _Shape: selectedProperty('Shape'),
          Size: selectedSize(),
          _Finish: selectedProperty('Finish'),
          Artwork: emailLater.checked ? 'I will email artwork later.' : file.name,
          'Artwork notes': artworkNotes.value.trim(),
          Quantity: root.dataset.offerQuantity,
          'Digital proof': 'You’ll receive a digital proof to approve before we print.',
          '_Product handle': root.dataset.productHandle,
          '_Deal product': 'true',
          '_Shipping mode': 'free',
        };
        if (file) {
          track('spark_artwork_upload_started');
          const upload = await uploadArtwork(file);
          track('spark_artwork_upload_succeeded', { durationMs: Math.round(performance.now() - journeyStarted) });
          properties._Artwork_manifest = upload.manifestToken;
          properties['_Artwork access'] = upload.artworkAccessUrl;
          properties.Artwork = `Received — ${file.name}`;
        }
        const formData = new FormData();
        journeyStage = 'cart';
        formData.append('id', selectedVariant.id);
        formData.append('quantity', '1');
        formData.append('sections', 'cart-drawer-section');
        formData.append('sections_url', window.location.pathname);
        Object.entries(properties).forEach(([key, value]) => formData.append(`properties[${key}]`, value));

        cartUpdate = CartLinesUpdateEvent.createPromise();
        root.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: String(selectedVariant.id), quantity: 1 }],
            promise: cartUpdate.promise,
          })
        );

        const payload = await addDealWithVerification(formData, selectedVariant.price);
        itemWasAdded = true;
        track('spark_deal_cart_succeeded');

        const cartResponse = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('The item was added, but the cart could not be refreshed.');
        const cart = await cartResponse.json();

        cartUpdate.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: {
            didError: false,
            itemCount: 1,
            items: cart.items,
            sections: payload.sections || {},
            source: 'spark-deal-product',
            sourceId: root.dataset.productHandle,
          },
        });
        document.querySelectorAll('.spark-cart-count').forEach((node) => {
          node.textContent = cart.item_count;
          node.classList.toggle('is-empty', cart.item_count === 0);
        });
        await openCartDrawer();
        setStatus('');
      } catch (error) {
        if (!itemWasAdded) track(journeyStage === 'upload' ? 'spark_artwork_upload_failed' : 'spark_deal_cart_failed', { stage: journeyStage, durationMs: Math.round(performance.now() - journeyStarted) });
        cartUpdate?.reject(error);
        if (itemWasAdded) {
          console.warn('[spark-deal-product] Item added; opening the cart after UI reconciliation failed.', error);
          setStatus('Item added. Opening your cart…');
          window.location.assign('/cart');
        } else {
          setStatus(error.message || 'Something went wrong. Please try Add to cart again now.', true);
        }
      } finally {
        loading = false;
        updateUi();
      }
    }

    async function addDealWithVerification(formData, expectedPrice) {
      // A unique private property identifies this write, including its artwork.
      // Never resend an uncertain POST: only inspect the existing cart.
      const attempt = crypto.randomUUID();
      formData.append('properties[_Cart attempt]', attempt);
      const expectedId = String(formData.get('id'));
      const properties = Object.fromEntries([...formData.entries()]
        .filter(([key]) => /^properties\[.*\]$/.test(key))
        .map(([key, value]) => [key.slice(11, -1), String(value)]));
      let response;
      try {
        response = await fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: formData });
        const payload = await response.json();
        if (!response.ok) throw new Error(payload.description || payload.message || 'Could not add this deal to the cart.');
        return payload;
      } catch (error) {
        if (response && response.status >= 400 && response.status < 500) throw error;
        setStatus('Checking whether your item reached the cart…');
        for (const delay of [750, 1750]) {
          await new Promise(resolve => setTimeout(resolve, delay));
          try {
            const read = await fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' }, signal: AbortSignal.timeout(8000) });
            if (!read.ok) continue;
            const cart = await read.json();
            const matches = cart.items?.filter(item => item.properties?.['_Cart attempt'] === attempt);
            if (matches?.length === 1) {
              const item = matches[0];
              if (String(item.variant_id) === expectedId && item.quantity === 1 && item.original_price === Number(expectedPrice)
                && Object.entries(properties).every(([key, value]) => String(item.properties?.[key] ?? '') === value)) {
                return { sections: {} };
              }
            }
          } catch { /* An unreadable cart cannot prove the write failed. */ }
        }
        throw new Error('We couldn’t confirm whether your item was added. Please check your cart before trying again to avoid adding it twice.');
      }
    }

    async function uploadArtwork(file) {
      const context = {stage:'authorization'};
      try { return await performArtworkUpload(file, context); }
      catch (error) {
        const files = [file];
        const details = {code:'configured_cart_failed', productHandle: root.dataset.productHandle, stage:'artwork-upload', uploadStage:context.stage, fileCount:files.length, fileBytes:files.reduce((n,f)=>n+f.size,0), fileTypes:[...new Set(files.map(f=>f.type||'unknown'))].slice(0,5).join(','), error:'Artwork upload failed', errorName:error.name||'Error', httpStatus:Number(error.status)||Number(context.httpStatus)||0, requestAborted:String(error.name==='AbortError'), pagePath:location.pathname};
        try { fetch('https://configurator.sparkstickers.com/api/configurator/cart-failure',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(details),keepalive:true}).catch(()=>{}); } catch {}
        throw error;
      }
    }

    async function performArtworkUpload(file, context) {
      const authorize = await retryFetch(`${uploadApiBase}/api/proofs/storefront-upload-authorize`, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ productHandle: root.dataset.productHandle, sessionId: sessionId(), files: [{ filename: file.name, contentType: file.type || 'application/octet-stream', size: file.size }] }) }, (attempt) => setStatus(`Connection interrupted. Retrying (${attempt} of ${MAX_UPLOAD_ATTEMPTS})...`));
      context.httpStatus = authorize.status;
      const authorization = await authorize.json();
      if (!authorize.ok || !authorization.uploads?.[0]) throw new Error(authorization.error || 'Could not prepare the artwork upload.');
      setStatus('Uploading artwork securely…');
      const upload = authorization.uploads[0];
      context.stage = 'direct-transfer';
      context.httpStatus = 0;
      try {
        const put = await retryFetch(upload.uploadUrl, { method: 'PUT', headers: { 'Content-Type': upload.contentType || file.type || 'application/octet-stream' }, body: file, signal: AbortSignal.timeout(120000) }, (attempt) => setStatus(`Connection interrupted. Retrying ${file.name} (${attempt} of ${MAX_UPLOAD_ATTEMPTS})...`));
        if (!put.ok) throw new Error(`Upload returned HTTP ${put.status}.`);
      } catch (directError) {
        if (!upload.relayToken) throw directError;
        setStatus('Reconnecting your secure artwork upload...');
        context.stage = 'relay-transfer';
        context.httpStatus = 0;
        track('spark_artwork_upload_recovery', { stage: 'file-transfer' });
        try {
          const relay = await fetch(`${uploadApiBase}/api/proofs/storefront-upload-relay`, {
            method: 'POST', headers: { 'Content-Type': upload.contentType, Authorization: `Bearer ${upload.relayToken}` },
            body: file, signal: AbortSignal.timeout(120000),
          });
          context.httpStatus = relay.status;
          if (!relay.ok) throw new Error(`Upload returned HTTP ${relay.status}.`);
        } catch {
          throw new Error('Your artwork could not be transferred. Download the file to your device and select it again, or choose Email artwork later to continue.');
        }
      }
      context.stage = 'completion';
      context.httpStatus = 0;
      const complete = await retryFetch(`${uploadApiBase}/api/proofs/storefront-upload-complete`, { method: 'POST', headers: { Accept: 'application/json', 'Content-Type': 'application/json' }, body: JSON.stringify({ authorizationToken: authorization.authorizationToken }) }, (attempt) => setStatus(`Connection interrupted. Retrying verification (${attempt} of ${MAX_UPLOAD_ATTEMPTS})...`));
      context.httpStatus = complete.status;
      const result = await complete.json();
      if (!complete.ok || !result.manifestToken || !result.artworkAccessUrl) throw new Error(result.error || 'Could not verify the artwork upload.');
      return {
        manifestToken: result.manifestToken,
        artworkAccessUrl: result.artworkAccessUrl
      };
    }

    function sessionId() {
      const key = 'spark-storefront-upload-session';
      const current = sessionStorage.getItem(key);
      if (current) return current;
      const value = `session_${crypto.randomUUID().replace(/-/g, '')}`;
      sessionStorage.setItem(key, value);
      return value;
    }

    async function retryFetch(url, options, onRetry) {
      let lastError;
      for (let attempt = 1; attempt <= MAX_UPLOAD_ATTEMPTS; attempt += 1) {
        try {
          const response = await fetch(url, { ...options, signal: options.signal || AbortSignal.timeout(30000) });
          if (!retryableStatus(response.status) || attempt === MAX_UPLOAD_ATTEMPTS) return response;
          lastError = new Error(`Upload service returned HTTP ${response.status}.`);
        } catch (error) {
          lastError = error;
          if (attempt === MAX_UPLOAD_ATTEMPTS) throw error;
        }
        onRetry(attempt + 1);
        await retryDelay(attempt);
      }
      throw lastError || new Error('The upload service could not be reached.');
    }

    function retryableStatus(statusCode) {
      return [408, 425, 429].includes(Number(statusCode)) || Number(statusCode) >= 500;
    }

    function retryDelay(attempt) {
      const delay = 400 * (2 ** (attempt - 1)) + Math.floor(Math.random() * 200);
      return new Promise((resolve) => window.setTimeout(resolve, delay));
    }

    async function openCartDrawer() {
      await customElements.whenDefined('theme-drawer');
      await new Promise((resolve) => requestAnimationFrame(resolve));
      const drawer = document.querySelector('theme-drawer#cart-drawer');
      if (typeof drawer?.open === 'function') {
        drawer.open();
        return;
      }
      window.location.assign('/cart');
    }

    setStatus('');
    updateUi();
  });
})();
